export default "__VITE_ASSET__CNBjKPU6__"